import { useSyncExternalStore } from 'react';
import { impersonationCookieName } from '../../server/utils/impersonation.ts';

const cookieRegexp = new RegExp(String.raw`(?:^|;\s*)${impersonationCookieName}=([^;]+)`);
const listeners = new Set<() => void>();

function readCookie(): string | undefined {
    return cookieRegexp.exec(document.cookie)?.[1];
}

function subscribe(handler: () => void): () => void {
    listeners.add(handler);
    return () => {
        listeners.delete(handler);
    };
}

function writeCookie(userId: string | undefined): void {
    if (userId) {
        document.cookie = `${impersonationCookieName}=${userId}; path=/; SameSite=Lax`;
    } else {
        document.cookie = `${impersonationCookieName}=; path=/; Max-Age=0`;
    }

    for (const handler of listeners) {
        handler();
    }
}

export function useImpersonation(): [string | undefined, (userId: string | undefined) => void] {
    const value = useSyncExternalStore(subscribe, readCookie, () => undefined);
    return [value, writeCookie];
}
